import React, { useEffect, useRef, useState } from "react";
import "./slideUp.scss";
// import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import close from "assets/ic_close.png";
import { useSlideUpStore } from "pages/Common/AppState";
import useGlobalSlideUp from "pages/Common/Hook/useGlobalSlideUp";

// const options = {
//     reserveScrollBarGap: true,
// };
const SlideUp = () => {
  const { closeSlideUp } = useGlobalSlideUp(false);
  const content = useSlideUpStore((state) => state.content);
  const hasCloseButton = useSlideUpStore((state) => state.hasCloseButton);
  const isOpen = useSlideUpStore((state) => state.isOpen);
  const [innerOpen, setInnerOpen] = useState(isOpen);
  const ref = useRef();
  useEffect(() => {
    if (isOpen) {
      setInnerOpen(true);
    } else {
      setTimeout(() => {
        setInnerOpen(false);
      }, 500);
    }
  }, [isOpen]);
  useEffect(() => {
    // if (innerOpen) {
    //   disableBodyScroll(ref.current);
    // } else {
    //   const doc = document.querySelector(".slide-up-inner.show");
    //   if (!doc) {
    //     enableBodyScroll(ref.current);
    //   }
    // }
    return () => {
      // clearAllBodyScrollLocks()
    };
  }, [innerOpen]);

  return (
    <div
      ref={ref}
      className={`slide-up common-full-width-extra ${innerOpen ? "show" : ""}`}
      onClick={closeSlideUp}
    >
      <div
        className={`slide-up-inner ${isOpen ? "show" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {hasCloseButton && (
          <img
            className="position-absolute hover"
            style={{ right: 20, top: 20 }}
            src={close}
            width={14}
            alt=""
            onClick={closeSlideUp}
          />
        )}
        {content}
      </div>
    </div>
  );
};

export default SlideUp;
